<mat-form-field>
  <mat-label>{{ 'sakp.departures.columns.claims' | translate }}</mat-label>
  <mat-select [(ngModel)]="selectedViolationId" (selectionChange)="onSelectionChange()">
    <mat-select-trigger *ngIf="selectedViolation as sv">
      <span [innerHTML]="sv.symbol"></span>&nbsp;{{ getViolationName(sv) }}
    </mat-select-trigger>
    <mat-option *ngFor="let v of violations" [value]="v.id">
      <span [innerHTML]="v.symbol"></span>&nbsp;{{ getViolationName(v) }}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field class="ml-2">
  <mat-label>{{ 'sakp.departures.columns.disputes-status' | translate }}</mat-label>
  <mat-select [(ngModel)]="selectedStatus" (selectionChange)="onSelectionChange()">
    <mat-option *ngFor="let s of statuses" [value]="s">{{ disputeStatusToSquare(s) }} {{ 'sakp.common.enums.dispute-status.' + s | translate }}</mat-option>
  </mat-select>
</mat-form-field>
